import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndpoints } from 'src/config/api-endpoints';

export interface SetDefaultPaymentRequest {
  userCreditCardID: string;
  userID: string;
  customerID: string;
  sessionID: string;
  walletID: string;
}

export interface SetDefaultPaymentResponse {
  statusCode: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class PpiPaymentMethodsService {

  constructor(private http: HttpClient) { }

public setDefaultPaymentMethod(
    request: SetDefaultPaymentRequest
  ): Observable<SetDefaultPaymentResponse> {
    const token = sessionStorage.getItem('headers');   // ✅ same as deletepaymentmethod
    let wallettoken=sessionStorage.getItem("walletheaders");
    const httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      }),
    };

    return this.http.post<SetDefaultPaymentResponse>(ApiEndpoints.dwSetDefaultPaymentUrl,request,httpOptions
    );
}
}
